import { jsx } from "react/jsx-runtime";
import NearMeDisabledIcon from "@mui/icons-material/NearMeDisabled";
import { validateTidalLicense } from "../../base/index.js";
function NearMeDisabled(props) {
  return /* @__PURE__ */ jsx(
    NearMeDisabledIcon,
    {
      "data-testid": "NearMeDisabled",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "NearMeDisabled",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
NearMeDisabled.tidalIconMeta = {
  categories: "map,location,time",
  name: "NearMeDisabled"
};
validateTidalLicense();
export {
  NearMeDisabled
};
//# sourceMappingURL=NearMeDisabled.js.map
